<!--  -->
<template>
  <div class="wrapper">
    <div class="gallery">
      <!-- <ul class="gallery-list">
      <li class="gallery-item" v-for="item in galleryList" :key="item.id">
        <el-image :src="item.imgUrl?item.imgUrl:defaultImg" :alt="item.title" fit="fill" :preview-src-list="[item.imgUrl]">
          <div slot="placeholder" class="image-slot">
            加载中<span class="dot">...</span>
          </div>
        </el-image>
      </li>
    </ul> -->
      <el-row v-if="routerName == 'TibetPlateau'">
        <el-col :span="8" v-for="(item) in galleryList" :key="item.id">
          <el-card :body-style="{ padding: '0px' }">
            <el-image class="image" :src="defaultImgHeader+item.f_cover_img+ossImage" :alt="item.title" fit="fill" :preview-src-list="[defaultImgHeader+item.f_cover_img]">
              <div slot="error" class="image-slot">
                No Image<span class="dot">...</span>
              </div>
            </el-image>
          </el-card>
        </el-col>

      </el-row>
      <el-row v-else>
        <el-col :span="8" v-for="(item) in galleryList" :key="item.id">
          <el-card :body-style="{ padding: '0px' }">
            <el-image class="image" :src="defaultImgHeader+item.fossil_img_path+ossImage" :alt="item.title" fit="fill" :preview-src-list="[defaultImgHeader+item.fossil_img_path]">
              <div slot="error" class="image-slot">
                No Image<span class="dot">...</span>
              </div>
            </el-image>
          </el-card>
        </el-col>
      </el-row>
      <p v-if="!galleryList.length" class="no-data">Temporarily no data</p>
      <!-- <v-page :showPagination="show" :event="getResult" @getList="getList" :limit="per_page" :totalPage="galleryTotalPage" :totalCount="totalCount"></v-page> -->
      <el-pagination @current-change="handleCurrentChange" :total="totalCount" :current-page="currentPage" :page-size="per_page" layout="prev,slot,next">
        <span class="rightPagination">
          {{currentPage}}/{{galleryTotalPage}}
        </span>
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getGallery,utlogMap } from "@/api/index";
import { functionId} from '@/utils/browser.js';
import VPage from "@/components/pagenation/index.vue";
import { deepBoneDomin, ossImage } from "@/common.js";
export default {
  components: {
    VPage,
  },
  props: ["nodeId", "gallery"],
  data() {
    return {
      defaultImgHeader: deepBoneDomin,
      ossImage: ossImage,
      galleryTotalPage: 1,
      totalCount: 1,
      per_page: 9,
      defaultImg: require("../../../assets/images/fish.png"),
      galleryList: [],
      specimensGallery: [],
      currentPage: 1,
      routerName: "",
      tibetName: "TibetPlateau",
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.routerName = this.$route.name;
    if (this.routerName == this.tibetName) return;
    this.getGallery();
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
      if (this.routerName == this.tibetName) {
        this.$set(
          this,
          "galleryList",
          this.specimensGallery.slice(
            this.per_page * (val - 1),
            this.per_page * val
          )
        );
      } else {
        this.getGallery();
      }
      let logMap = {
        eventType: "clk",
        url: window.location.href,
        functionId: (this.routerName == this.tibetName)?'Deepbone_tibet_galleryPageChange': 'Deepbone_explore_galleryPageChange',
      };
      utlogMap(logMap).then((res) => {
        // console.log(res);
      });
    },
    getResult(page) {
      return getGallery(this.nodeId, this.per_page, page);
    },
    getGallery() {
      getGallery(this.nodeId, this.per_page, this.currentPage).then((res) => {
        let data = res.data?.data || [];
        let meta = res.data?.meta || {};
        let { totalCount = 0, totalPage = 0 } = meta;
        this.galleryTotalPage = totalPage;
        this.totalCount = totalCount;
        this.$set(this, "galleryList", data);
      });
    },
    getList(list) {
      this.$set(this, "galleryList", list);
    },
  },
  watch: {
    nodeId: function (newVal, oldVal) {
      if (this.routerName == this.tibetName) {
        return;
      }
      if (newVal != oldVal && newVal != "") {
        this.currentPage = 1;
        this.getGallery();
      }
    },
    gallery: function (val) {
      if (val) {
        this.specimensGallery = val.filter(
          (el) => el.f_cover_img != "null" && el.f_cover_img != null
        );
        this.galleryTotalPage = Math.ceil(val.length / this.per_page);
        this.$set(this, "specimensGallery", val); //第一次获取全部的specimensGallery数据

        this.totalCount = this.specimensGallery.length;

        this.$set(
          this,
          "galleryList",
          this.specimensGallery.slice(0, this.per_page)
        );
      }
    },
  },
};
</script>
<style>
.gallery {
  width: 100%;
  min-height: 400px;
  overflow: hidden;
  padding-bottom: 32px;
  position: relative;
}
.gallery-list {
  display: flex;
  width: 100%;
  height: 100%;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.gallery-list .gallery-item {
  /* width: calc(33.3% - 8px);
  float: left; */
  border: 2px solid #efefef;
  padding: 10px 8px;
  margin-right: 8px;
  margin-bottom: 8px;
  max-width: 350px;
}
/* .gallery-item  */
.gallery .image {
  max-width: 100%;
  height: 100%;
  width: 100%;
}
.el-col {
  border: 2px solid #efefef;
  padding: 5px 4px;
  margin-right: 0.33333%;
}
.el-col-8 {
  width: 33% !important;
  margin-bottom: 5px;
}
.el-card {
  border-radius: 0px;
  border: none;
  height: 180px;
}
.el-image__inner {
  width: 100%;
}
.el-card.is-always-shadow {
  box-shadow: unset;
}
.el-card__body {
  width: 100%;
  height: 100%;
}
</style>
